import React from "react";
import { Box, Typography, useTheme } from "@mui/material";
import FlexBetween from "./FlexBetween";

const SceneBox = ({ value, icon, onClick }) => {
  const theme = useTheme();
  return (
    <Box
      onClick={onClick}
      sx={{
        cursor: "pointer",
        '&:hover': {
          backgroundColor: theme.palette.grey[800], '& .MuiSvgIcon-root': {
            color: theme.palette.secondary[500],
          },
        }
      }}
      gridColumn="span 2"
      gridRow="span 1"
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      p="1.25rem 1rem"
      flex="1 1 100%"
      backgroundColor={theme.palette.background.alt}
      borderRadius="0.55rem"
    >
      <FlexBetween>
        {icon}
        <Typography
        marginLeft={2}
        variant="h4"
        fontWeight="600"
        sx={{ color: theme.palette.grey[400] }}
      >
        {value}
        </Typography>
        </FlexBetween>
    </Box>
  );
};

export default SceneBox;
